import React, { useState, useRef } from "react";
import Header01 from "../components/Headers/Header01";
import { alphabets } from "../Data";
import ReactPlayer from "react-player";
import PlayOverlay from "../components/PlayOverlay";
import { motion } from "framer-motion";
// import NextPreviousBTN from "../components/NextPreviousBTN";
// import AudioPlayer from "../components/AudioPlayer";

type Props = {};

const NowYouSay = (props: Props) => {
  const [CurrentLetter] = useState<number>(0);
  const [ClickToPlay, setClickToPlay] = useState<boolean>(true);

  const playerRef = useRef<ReactPlayer | null>(null);
  const [Audio, setAudio] = useState<null | string>(null);
  const [Playing, setPlaying] = useState<boolean>(false);

  return (
    <div
      className={`w-full h-screen flex flex-col justify-between overflow-hidden z-0`}
    >

      {/* <div className="hidden">
        <BgAudioPlayer ClickToPlay={ClickToPlay} />
      </div> */}

      {Audio && Playing ? (
        <div className="hidden">
          <ReactPlayer
            url={Audio}
            config={{
              file: { forceAudio: true },
            }}
            onPlay={() => {
              console.log("Audio Playing");
            }}
            onEnded={() => {
              setPlaying(false);
            }}
            loop={false}
            controls
            playing={Playing}
            ref={playerRef}
          />
        </div>
      ) : null}

      <Header01 letter={alphabets[CurrentLetter]} />

      {ClickToPlay ? <PlayOverlay setClickToPlay={setClickToPlay} /> : 
        // body
      <div className={`w-full`}>
        <div
          className={`flex flex-row justify-between h-[75%] w-full bottom-[-3%] lg:px-[10%] z-0 fixed`}
        >
          {/* Trees */}
          <motion.img
            initial={{ x: -1000}}
            animate={{ x: 0}}
            transition={{ delay: 1.2 }}
            src="/Others/Tree.png" 
            alt="tree" 
            className="pt-20 md:w-1/3 lg:w-1/4" 
          />
          <motion.img
            initial={{ x: 1000}}
            animate={{ x: 0}}
            transition={{ delay: 1.2 }}
            src="/Animals/ParrotOnTree.png"
            alt="tree bird"
            className="md:w-1/3 lg:w-1/4"
          />
          {/* Character */}
          <motion.img
            initial={{ x: -1000}}
            animate={{ x: 0}}
            transition={{ delay: 1.5 }}
            src="/Characters/Wilf.png"
            alt="Wilf"
            className={`absolute bottom-0 lg:left-[16%] md:left-[12%] z-10 h-[70%] lg:h-[80%]`}
          />
          {/* Character Bubble chat */}
          <motion.div
            initial={{ x: -1000}}
            animate={{ x: 0}}
            transition={{ delay: 1.8 }}
            // whileHover={{ scale: 1.5 }}
            whileTap={{
              rotate: [0, -10, 10, -10, 10, 0],
              transition: { duration: 0.3 },
            }}
            className={`absolute bottom-[20%] left-[30%] z-10 w-60 h-60 py-10 cursor-pointer`}
            onClick={() => {
              if (Playing === false) {
                setAudio("/music/A_speech.mp3");
                setPlaying(true);
              } else {
                setPlaying(false);
                setAudio(null);
              }
            }}
          >
            <div className="relative">
              <img
                src="/Others/SpeechBubble.png"
                alt="Wilf"
                className={`transform rotate-180`}
              />
              <div className="absolute inset-0 flex justify-center items-center mt-3 z-15">
                <h4 className={`font-extrabold lg:text-8xl text-6xl word-primary`}>
                  {alphabets[CurrentLetter]}
                </h4>
              </div>
            </div>
          </motion.div>
          {/* Parrot Bubble chat */}
          <motion.div
            initial={{ x: 1000}}
            animate={{ x: 0}}
            transition={{ delay: 1.8 }}
            // whileHover={{ scale: 1.5 }}
            whileTap={{
              rotate: [0, -10, 10, -10, 10, 0],
              transition: { duration: 0.3 },
            }}
            className={`absolute top-0 right-[30%] z-10 w-60 h-60 py-10 cursor-pointer`}
            onClick={() => {
              if (Playing === false) {
                setAudio("/music/NowYouSayA.mp3");
                setPlaying(true);
              } else {
                setPlaying(false);
                setAudio(null);
              }
            }}
          >
            <div className="relative">
              <img src="/Others/SpeechBubble.png" alt="Wilf" className={``} />
              <div className="absolute inset-0 mb-16 flex flex-col justify-center items-center z-15">
                <p className={`font-extrabold lg:text-3xl text-2xl`}>
                  Now You Say
                </p>
                <h4 className={`font-extrabold lg:text-8xl text-6xl word-primary`}>
                  '{alphabets[CurrentLetter]}'
                </h4>
              </div>
            </div>
          </motion.div>
        </div> 
      </div>
      }

      {/* Next Previous buttons */}
      {/* <NextPreviousBTN setCurrentLetter={setCurrentLetter} CurrentLetter={CurrentLetter}/> */}
    </div>
  );
};

export default NowYouSay;
